<template>
  <multiselect
    :value="value"
    :label="label"
    :track-by="label"
    :options="options"
    :tag-placeholder="tagPlaceholder"
    select-label=""
    selected-label=""
    deselect-label=""
    :placeholder="placeholder ? placeholder : ''"
    :open-direction="openDirection"
    :internal-search="internalSearch"
    :show-no-results="true"
    :clear-on-select="clearOnSelect"
    :close-on-select="closeOnSelect"
    :hide-selected="hideSelected"
    :multiple="multiple"
    :taggable="taggable"
    :searchable="searchable"
    :dir="dir"
    :disabled="disabled"
    :limit="attributetype === 'common filter' ? 0 : undefined"
    :limit-text="attributetype === 'common filter' ? displayText : undefined"
    :class="attributetype === 'multiselect' ? 'multiselect' : 'singleselect'"
    @remove="
      attributetype === 'multiselect' ? $emit('remove', $event) : $emit('clear')
    "
    @select="$emit('select', $event)"
    @tag="$emit('tag', $event)"
    @search-change="onSearch"
  >
    <template
      v-if="attributetype === 'common filter' || attributetype === 'common filter select' || customizeLabel"
      slot="singleLabel"
      slot-scope="item"
    >
      <span v-if="attributetype === 'common filter' || attributetype === 'common filter select'">{{ placeholder }}</span>
      <slot v-else name="singleLabel" :item="item" />
    </template>
    <template v-if="customizeOption" slot="option" slot-scope="item">
      <slot name="option" :item="item" />
    </template>
    <template
      v-if="attributetype === 'multiselct'"
      slot="tag"
      slot-scope="{ option }"
    >
      <span class="custom__tag">
        <span>{{ option.name }}</span>
        <span class="custom__remove" @click.prevent="$emit('remove', option)">
          <i class="fas fa-times"></i>
        </span>
      </span>
    </template>
    <template slot="clear">
      <span
        v-if="checkCleanButton && !disabled"
        class="multiselect__clear"
        @click.prevent.stop="$emit('clear')"
      >
        <i class="fas fa-lg fa-eraser"></i>
      </span>
    </template>
    <span slot="noOptions">
      {{ noOptions ? noOptions : $t('Digit at least {n} character', { n: this.minLength }) }}
    </span>
    <span slot="noResult">{{ $t(noResult) }}</span>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { debounce } from 'lodash'

export default {
  name: 'MultiselctThux',
  components: {
    multiselect: Multiselect
  },
  props: {
    options: {
      required: true
    },
    value: {
      required: true
    },
    attributetype: {
      required: true
    },
    label: {
      default: undefined
    },
    disabled: {
      default: false
    },
    hideSelected: {
      default: false
    },
    showCleanButton: {
      default: true
    },
    closeOnSelect: {
      default: true
    },
    dir: {
      default: 'ltr'
    },
    openDirection: {
      default: 'bottom'
    },
    customizeOption: {
      default: false
    },
    customizeLabel: {
      default: false
    },
    message: {},
    noOptions: {},
    placeholder: {},
    minLength: {
      default: 2
    },
    internalSearch: {
      default: true
    },
    taggable: {
      default: false
    },
    tagPlaceholder: {
      default: ''
    }
  },
  data () {
    return {
      multiple: false,
      searchable: true,
      clearOnSelect: true,
      noResult: 'Loading...'
    }
  },
  computed: {
    checkCleanButton () {
      if (this.value && this.showCleanButton) {
        if (Array.isArray(this.value)) {
          return this.value.length !== 0
        }
        return true
      }
      return false
    }
  },
  created () {
    this.setConfig()
  },
  methods: {
    setConfig () {
      if (this.attributetype === 'multiselect') {
        this.multiple = true
      } else if (this.attributetype === 'select' || this.attributetype === 'common filter select') {
        this.searchable = false
      } else if (this.attributetype === 'common filter') {
        this.clearOnSelect = false
      }
    },
    onSearch: debounce(function (search) {
      if (search.length < this.minLength) {
        this.$set(
          this,
          'noResult',
          this.$t('Digit at least {n} character', { n: this.minLength })
        )
      } else {
        this.$set(this, 'noResult', this.$t('Loading...'))
        setTimeout(() => {
          this.$set(
            this,
            'noResult',
            'Oops! No elements found. Consider changing the search query.'
          )
        }, 1000)
      }
      this.$emit('search', search)
    }, 500),
    displayText (count) {
      if (count === 0) {
        return ''
      } else if (this.message) {
        return count + ' ' + this.message
      }
    }
  }
}
</script>
